import { isString } from '../utils'
import qs from 'qs'

const getQueryParamsObj = (): URLSearchParams => {
  const queryString = window.location.search
  return new URLSearchParams(queryString)
}

const hasQueryParam = (key: string): boolean => {
  return getQueryParamsObj().has(key)
}

const getQueryParam = (key: string): string | null => {
  const possibleQueryParam = getQueryParamsObj().get(key)

  if (possibleQueryParam === null) return possibleQueryParam

  return decodeURI(possibleQueryParam)
}

const getHashParamsObj = (): URLSearchParams => {
  const queryString = window.location.hash.replace('#', '&')
  return new URLSearchParams(queryString)
}

const hasHashParam = (key: string): boolean => {
  return getHashParamsObj().has(key)
}

const getHashParam = (key: string): string | null => {
  const paramsObj = getHashParamsObj().get(key)
  if (isString(paramsObj)) return decodeURI(paramsObj)
  return null
}

const clearAllParams = (): string => {
  history.replaceState(null, '', window.location.pathname)
  window.location.hash = ''
  return window.location.href
}

const clearParam = (param: string): void => {
  const params = new URLSearchParams(window.location.search)
  params.delete(param)

  const newParams: Record<string, string> = {}
  params.forEach((value, key) => {
    newParams[key] = value
  })

  const resultParams =
    Object.keys(newParams).length === 0
      ? ''
      : `?${qs.stringify(newParams)}`

  history.replaceState(
    null,
    '',
    `${window.location.pathname}${resultParams}`,
  )
}

const clearParams = (paramsToDelete: string[]): void => {
  const params = new URLSearchParams(window.location.search)
  paramsToDelete.forEach((p) => {
    params.delete(p)
  })
  const newParams: Record<string, string> = {}
  params.forEach((value, key) => {
    newParams[key] = value
  })

  const resultParams =
    Object.keys(newParams).length === 0
      ? ''
      : `?${qs.stringify(newParams)}`

  history.replaceState(
    null,
    '',
    `${window.location.pathname}${resultParams}`,
  )
}

const checkUrlQueryParams = (params: string[]): boolean => {
  return params.every((param) => {
    return hasQueryParam(param)
  })
}

const checkUrlHashParams = (params: string[]): boolean => {
  return params.every((param) => {
    return hasHashParam(param)
  })
}

const isCookieEnabled = (): boolean => {
  if (navigator.cookieEnabled) return true

  // setea y borra una cookie para navegadores antiguos que no tienen el
  // api navigator
  document.cookie = 'cookietest=1'
  const isSetted = document.cookie.includes('cookietest=')
  // delete cookie
  document.cookie =
    'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT'

  return isSetted
}

const isSessionStorageAvailable = (): boolean => {
  return typeof sessionStorage !== 'undefined'
}

const isLocalStorageAvailable = (): boolean => {
  return typeof localStorage !== 'undefined'
}

const urlUtils = {
  getQueryParamsObj,
  hasQueryParam,
  getQueryParam,
  clearAllParams,
  checkUrlQueryParams,
  getHashParamsObj,
  hasHashParam,
  getHashParam,
  checkUrlHashParams,
  clearParam,
  clearParams,
}

export {
  urlUtils,
  isCookieEnabled,
  isSessionStorageAvailable,
  isLocalStorageAvailable,
}
